<template>
  <div class="cart">
    <GlobTopNav :title="$common.cardName().name" :rightHidden="false">
      <div @click="onClickRight">
        <span v-if="!redact">编辑</span>
        <span v-if="redact">完成</span>
      </div>
    </GlobTopNav>

    <div class="van-content">
      <div class="nodata text-cent" v-if="finished && datas == ''">
        <img src="./../../../assets/img/cart-nulll.png" />
        <span class="text">{{ $common.cardName().name }}空空哒~</span>
        <div @click="go()" class="visit-the">去逛逛</div>
      </div>

      <van-list v-model="loading" :finished="finished" @load="getDatas" :offset="-1">
        <van-checkbox-group v-model="onDatas" ref="checkboxGroup">
          <van-checkbox
            v-for="(items, index) in datas"
            :name="items"
            :key="items.id"
            :disabled="items.status == 0 && !redact ? true : false"
            checked-color="rgba(226, 49, 48, 1)"
          >
            <van-swipe-cell :right-width="60" :left-width="0" :disabled="redact">
              <van-cell-group>
                <van-card class="goodsonelist">
                  <router-link
                    slot="thumb"
                    class="goodsimgbox"
                    :to="{ path: '/goodslist/goods', query: { id: items.goods_id } }"
                  >
                    <img onerror="src='/static/errorimg1.png'" :src="items.image" />
                    <span class="overGood" v-if="items.status == 0">
                      <span>下架</span>
                    </span>
                  </router-link>

                  <div slot="title" class="van-card-title" style="-webkit-box-orient: vertical; ">
                    <span class="tagbox">
                      <span class="tag xl" v-if="items.source == 4"> 一乡一物 </span>
                      <span class="tag xl" v-if="items.source == 3">卡券</span>
                      <span class="tag zc" v-if="items.source == 2">直充</span>
                      <span plain class="tag jd" v-if="items.source == 1">优选</span>
                      <span class="tag yx" v-if="items.source == 6">严选</span>
                    </span>
                    {{ items.name }}
                  </div>
                  <div slot="desc" class="theme-col">
                    <div class="stock-wrap" v-if="stockShow">
                      <span v-if="items.stock_status === 1">库存：{{ items.stock_number }}</span>
                      <span v-if="items.stock_member_status === 1">
                        剩余兑换数量：{{ items.stock_member_number - items.stock_member_count < 0 ? 0 : items.stock_member_number - items.stock_member_count }}
                      </span>
                    </div>
                    <div class="van-card-desc">
                      <div class="product-price">
                        <span v-if="items.point">
                          <span>{{ items.status == 1 ? items.point : '已下架' }}</span>
                          <span>{{ items.status == 1 ? unit : '' }}</span>
                        </span>
                        <span v-if="items.cash && items.status == 1">
                          <span><span v-if="items.point">+</span>{{ items.cash }}</span>
                          <span>元</span>
                        </span>
                      </div>
                      <div slot="footer">
                        <!--<van-stepper v-model="items.number" :change="changeNum(items.cart_id,items.number,index)" />-->
                        <div v-if="!redact" class="van-stepper">
                          <button
                            :class="items.number == 1 ? 'van-stepper__minus--disabled' : ''"
                            class="van-stepper__minus"
                            @click.stop="cuts(index, items.cart_id)"
                          ></button>
                          <input
                            v-on:blur="descInput(index, items.number, items.cart_id)"
                            v-model="items.number"
                            type="number"
                            class="van-stepper__input"
                          />
                          <button
                            @click.stop="add(index, items.cart_id)"
                            class="van-stepper__plus"
                          ></button>
                        </div>
                        <van-icon
                          v-if="redact == true"
                          class="iconfont icon-shanchu ft3"
                          size=".32rem"
                          @click.stop="removeGoods(items.cart_id, index)"
                        ></van-icon>
                      </div>
                    </div>
                  </div>
                </van-card>
              </van-cell-group>
              <span slot="right">
                <button
                  class="clearbtn theme-bd theme-bg"
                  @click="removeGoods(items.cart_id, index)"
                >
                  删除
                </button>
              </span>
            </van-swipe-cell>
          </van-checkbox>
        </van-checkbox-group>
        <div v-if="!loading && finished && datas != ''" class="nomore">
          <div class="theEnd">已经到底了</div>
        </div>
      </van-list>
    </div>

    <div class="van-submit-bar" v-if="datas.length > 0">
      <div class="van-submit-bar__bar">
        <van-checkbox
          v-model="checkedall"
          checked-color="rgba(226, 49, 48, 1)"
          style="margin-left: 0.15rem"
          @click="changeChecked"
        >
          全选
        </van-checkbox>
        <div class="van-submit-bar__price">
          <span class="ft2" v-if="!redact">合计：</span>
          <span v-if="!redact" class="van-submit-bar__price-integer theme-col ft2">
            {{ points_prices }}
            <!--<span v-if="money_price != 0">+¥{{ money_price.toFixed(2) }}元</span>-->
          </span>
        </div>
        <button
          v-if="!redact"
          class="van-button theme-bg van-button--normal payorder"
          @click="buyBtn()"
        >
          <span class="van-button__text">立即下单</span>
        </button>
        <button
          v-if="redact"
          class="van-button theme-bd theme-col van-button--normal payorder bg-fff removeOrder"
          @click="buyBtn()"
        >
          <span class="van-button__text">删除</span>
        </button>
      </div>
    </div>

    <!--底部导航-->
    <footer-nav></footer-nav>
  </div>
</template>

<script>
import FooterNav from "@/components/footernav";
import Bus from "../../../../static/js/bus.js";
export default {
  name: "cart",
  components: {
    FooterNav
  },
  data() {
    return {
      checkedall: false,
      datas: [],
      onDatas: [],
      page: 0,
      finished: false,
      loading: false,
      redact: false, //编辑开关
      carnum1: [],
      carnum2: [],
      goodsdown: false
    };
  },
  // watch: {
  //   checkedall: function () {
  //     var _this = this
  //     if (this.checkedall) {
  //       _this.onDatas = []
  //       $.each(this.datas, function (index, items) {
  //         _this.onDatas.push(items)
  //       })
  //     }
  //     if (!this.checkedall && this.onDatas.length == this.datas.length) {
  //       _this.onDatas = []
  //     }
  //   },
  //   datas: function () {
  //     this.onDatas.length == this.datas.length
  //       ? (this.checkedall = true)
  //       : (this.checkedall = false)
  //   },
  //   onDatas: function () {
  //     this.onDatas.length == this.datas.length
  //       ? (this.checkedall = true)
  //       : (this.checkedall = false)
  //   }
  // },

  computed: {
    unit: function() {
      return this.$store.state.unitinfo.name;
    },
    //积分价格
    points_prices: function() {
      var _this = this;
      var total = 0;
      var totalCash = 0;
      $.each(_this.onDatas, function(index, items) {
        total += items.number * items.point;
        totalCash += items.number * items.cash;
      });

      if (!totalCash) {
        return `${total}${this.unit}`;
      }

      if (!total) {
        return `${totalCash}元`;
      }

      if (totalCash && total) {
        return `${total}${this.unit} + ${totalCash}元`;
      }
    },
    //现金价格
    money_price: function() {
      var _this = this;
      var total = 0;
      $.each(_this.onDatas, function(index, items) {
        total += items.nums * items.money_price;
      });
      return total;
    },
    stockShow: function() {
      return this.$store.state.mallStockShow;
    }
  },
  methods: {
    changeChecked() {
      this.$refs.checkboxGroup.toggleAll({
        checked: this.checkedall,
        skipDisabled: true
      });
    },
    goBack: function() {
      history.back(-1);
    },
    onClickRight: function() {
      this.redact = !this.redact;
    },
    go: function() {
      this.$router.push({ path: "/goodsList", query: { id: -1 } });
    },
    descInput(idx, num, id) {
      if (num < 0) {
        num = 1;
        this.datas[idx].number = 1;
        this.$toast("数量必须为正整数！");
      }
      if (num >= 9999) {
        num = 9999;
        this.datas[idx].number = 9999;
      }

      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      var reg = /^[1-9]\d*$/;
      if (num > 0) {
        if (reg.test(num)) {
          this.$api.post(
            "user/cart/product",
            {
              id_example: mallid,
              token_user: isUser,
              id_cart: id,
              number: this.datas[idx].number
            },
            res => {
              if (res.data.code == "100") {
              } else {
                if (res.data.message == "token验证失败") {
                  this.$dialog
                    .confirm({
                      title: "提示 ",
                      message: "您还未登录是否去登录？"
                    })
                    .then(() => {
                      this.$router.push({ name: "NoteLogin" });
                    })
                    .catch(() => {});
                } else {
                  this.$toast(res.data.message);
                }
              }
            }
          );
        } else {
          var n = num.split(".")[0];
          this.datas[idx].number = n;
          this.onDatas = [];
          this.$toast("数量必须为正整数！");
        }
      } else {
        this.$toast("请输入数量！");
      }
    },

    cuts: function(idx, id) {
      //减
      this.datas[idx].number--;
      if (this.datas[idx].number < 1) {
        this.datas[idx].number = 1;
        return false;
      }
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      this.$api.post(
        "user/cart/product",
        {
          id_example: mallid,
          token_user: isUser,
          id_cart: id,
          number: this.datas[idx].number
        },
        res => {
          if (res.data.code == "100") {
          } else {
            if (res.data.message == "token验证失败") {
              this.$dialog
                .confirm({
                  title: "提示 ",
                  message: "您还未登录是否去登录？"
                })
                .then(() => {
                  this.$router.push({ name: "NoteLogin" });
                })
                .catch(() => {});
            } else {
              this.$toast(res.data.message);
            }
          }
        }
      );
    },
    add: function(idx, id) {
      //加
      this.datas[idx].number++;
      if (this.datas[idx].number < 0) {
        this.datas[idx].number = 1;
      }

      if (this.datas[idx].number >= 9999) {
        this.datas[idx].number = 9999;
      }

      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      this.$api.post(
        "user/cart/product",
        {
          id_example: mallid,
          token_user: isUser,
          id_cart: id,
          number: this.datas[idx].number
        },
        res => {
          if (res.data.code == "100") {
          } else {
            if (res.data.message == "token验证失败") {
              this.$dialog
                .confirm({
                  title: "提示 ",
                  message: "您还未登录是否去登录？"
                })
                .then(() => {
                  this.$router.push({ name: "NoteLogin" });
                })
                .catch(() => {});
            } else {
              this.$toast(res.data.message);
            }
          }
        }
      );
    },
    buyBtn: function() {
      var _this = this;
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      if (this.redact && this.onDatas.length != 0) {
        this.$dialog
          .confirm({
            title: "提示",
            message: "确定删除该商品吗？"
          })
          .then(() => {
            var onDatasId = [];
            $.each(this.onDatas, function(index, items) {
              onDatasId.push(items.cart_id);
            });
            var strOnDatasId = JSON.stringify(
              onDatasId
            ); /*.replace(/\"/g, "")*/ /*.replace(/^\{/gi, '').replace(/\}$/gi, '')*/
            this.$api.post(
              "user/cart/delete",
              { id_example: mallid, token_user: isUser, cart_id: onDatasId },
              res => {
                if (res.data.code == "100") {
                  this.$toast("删除成功！");
                  $.each(this.onDatas, function(index, items) {
                    _this.datas.splice($.inArray(items, _this.datas), 1);
                  });
                  this.onDatas = [];
                  this.$api.get(
                    "user/cart/list",
                    { id_example: mallid, token_user: isUser },
                    res => {
                      if (res.data.code == "100") {
                        if (res.data.data.length != 0) {
                          $.each(res.data.data, function(items, index) {
                            if (!_this.datas[items]) {
                              _this.datas.push(items);
                            }
                          });
                        }
                      } else {
                        if (res.data.message == "token验证失败") {
                          this.$dialog
                            .confirm({
                              title: "提示 ",
                              message: "您还未登录是否去登录？"
                            })
                            .then(() => {
                              this.$router.push({ name: "NoteLogin" });
                            })
                            .catch(() => {});
                        } else {
                          this.$toast(res.data.message);
                        }
                      }
                    }
                  );
                } else {
                  this.$toast(res.data.message);
                }
              }
            );
          })
          .catch(() => {
            return false;
          });
      } else if (!this.redact && this.onDatas.length != 0) {
        const url = window.location.href
        const isResetting = localStorage.getItem('isResetting')
        if(url.search('kmzhfl') != -1 && isResetting == 1) {
        // if(url.search('geren') != -1 && isResetting == 1) {
          this.$dialog.confirm({
              title: "提示 ",
              message: "为了你的账号安全，请修改初始密码后在下单"
            })
              .then(() => {
                this.$router.push({ name: "Password" });
              })
              .catch(() => {
                
              });
          return
        } 
        var onDatasId = [];
        $.each(this.onDatas, function(index, items) {
          if (items.status == 0) {
            //下架商品
            _this.goodsdown = true;
            _this.$dialog
              .alert({
                title: "提示",
                message: "下架商品无法下单！"
              })
              .then(() => {
                _this.onDatas = [];
                onDatasId = [];
                _this.goodsdown = false;
                // on close
              });
          } else if(items.stock_member_status === 1 && items.stock_member_number - (items.stock_member_count + items.number) < 0) {
            _this.goodsdown = true;
            _this.$dialog
              .alert({
                title: "提示",
                message: items.name + "剩余可兑换数超出限制"
              })
              .then(() => {
                _this.onDatas = [];
                onDatasId = [];
                _this.goodsdown = false;
                // on close
              });
          } else {
            onDatasId.push(items.cart_id);
          }
        });
        var strOnDatasId = JSON.stringify(
          onDatasId
        ); /*.replace(/\"/g, "")*/ /*.replace(/^\{/gi, '').replace(/\}$/gi, '')*/
        
        if (this.goodsdown == false) {
          this.$api.post(
            "/order/cart/create",
            { id_example: mallid, token_user: isUser, id_cart: onDatasId },
            res => {
              if (res.data.code == "100") {
                this.$router.push({
                  path: "/affirmOrder",
                  query: { id: onDatasId }
                });
              } else {
                if (res.data.message == "token验证失败") {
                  this.$dialog
                    .confirm({
                      title: "提示 ",
                      message: "您还未登录是否去登录？"
                    })
                    .then(() => {
                      this.$router.push({ name: "NoteLogin" });
                    })
                    .catch(() => {});
                } else if (res.data.code == "-200") {
                  this.$dialog
                    .confirm({
                      title: "提示",
                      message: `你的${this.unit}余额不足\n是否购买${this.unit}`
                    })
                    .then(() => {
                      this.$router.push({
                        name: "Buypoints",
                        params: { points: res.data.message }
                      });
                    })
                    .catch(() => {});
                } else {
                  this.$toast(
                    this.$common.cardName().type ? "余额不足" : res.data.message
                  );
                }
              }
            },
            err => {
              this.$router.push({ name: "Overtime" });
            }
          );
        }
      } else {
        if (this.redact) {
          this.$toast("请选择要删除的商品！");
        } else {
          this.$toast("请选择要兑换的商品！");
        }
      }
    },
    getDatas: function() {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      var _this = this;
      //        setTimeout(() => {
      //          this.page++
      this.$api.get(
        "user/cart/list",
        { id_example: mallid, token_user: isUser },
        res => {
          if (res.data.code == "100") {
            _this.finished = true;
            _this.loading = false;
            if (res.data.data.length == 0) {
              _this.finished = true;
              _this.loading = false;
            } else {
              for (let i = 0; i < res.data.data.length; i++) {
                _this.datas.push(res.data.data[i]);
              }
              _this.loading = false;
            }
          } else {
            _this.finished = true;
            _this.loading = false;
          }
        },
        err => {
          this.$router.push({ name: "Overtime" });
        }
      );
      //        },50)
    },
    removeGoods: function(id, index) {
      var _this = this;
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      this.$dialog
        .confirm({
          title: "提示",
          message: "确定删除该商品吗？"
        })
        .then(() => {
          this.$api.post(
            "user/cart/delete",
            { id_example: mallid, token_user: isUser, cart_id: id },
            res => {
              if (res.data.code == "100") {
                this.$toast(res.data.message, 123);
                if ($.inArray(this.datas[index], this.onDatas) != -1) {
                  this.onDatas.splice(
                    $.inArray(this.datas[index], this.onDatas),
                    1
                  );
                }
                this.datas.splice(index, 1);
                this.$api.get(
                  "user/cart/list",
                  { id_example: mallid, token_user: isUser },
                  res => {
                    if (res.data.code == "100") {
                      if (res.data.data.length != 0) {
                        $.each(res.data.data, function(items, index) {
                          if (!_this.datas[items]) {
                            _this.datas.push(items);
                          }
                        });
                      }
                    } else {
                      if (res.data.message == "token验证失败") {
                        this.$dialog
                          .confirm({
                            title: "提示 ",
                            message: "您还未登录是否去登录？"
                          })
                          .then(() => {
                            this.$router.push({ name: "NoteLogin" });
                          })
                          .catch(() => {});
                      } else {
                        this.$toast(res.data.message);
                      }
                    }
                  }
                );
              }
            }
          );
        })
        .catch(() => {
          // on cancel
        });
    }
  },
  mounted() {}
};
</script>
<style lang="less">
.cart {
  background: #f5f5f5;
  min-height: 100vh;
  padding-bottom: 1rem;
  .van-nav-bar {
    z-index: 999 !important;
  }

  .payorder {
    width: 2.5rem;
    height: 0.8rem;
    background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
    border-radius: 0.48rem;
    border: none;

    .van-button__text {
      color: #fff !important;
    }
  }

  .removeOrder {
    width: 2.5rem;
    height: 0.8rem;
    background: #fdf5f5;
    border-radius: 0.5rem;
    border: 0.02rem solid #e23331;
    font-size: 0.3rem;
    font-weight: 500;
    line-height: 0.42rem;

    .van-button__text {
      color: #e23331 !important;
    }
  }

  .ellipseal {
    // display: -webkit-box;
    // -webkit-box-orient: vertical;
    // -moz-box-orient: vertical;
    // box-orient: vertical;
    // -webkit-line-clamp: 2;
    // line-clamp: 2;
    // overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical !important;
    // autoprefixer: ignore next
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .footNav {
    z-index: 99;
  }
  .van-submit-bar {
    height: 1.2rem;
    bottom: 1.1rem;

    .van-submit-bar__bar {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      box-sizing: border-box;

      .van-checkbox {
        .van-checkbox__label {
          font-size: 0.26rem;
          font-weight: 400;
          color: #262626;
          line-height: 0.36rem;
        }
      }

      .van-submit-bar__price {
        -ms-flex: 1;
        flex: 1;
        display: flex;
        align-items: center;
        text-align: left;
        color: #666;
        padding: 0 0.12rem;
        font-size: 0.26rem;
        font-weight: 400;
        color: #262626;
        line-height: 0.36rem;
        color: rgba(254, 92, 66, 1) !important;
      }

      .ft2 {
        color: rgba(254, 92, 66, 1) !important;
      }
    }
  }

  .van-swipe-cell {
    margin-left: 0.35rem;
  }
  .van-cell-group {
    margin-bottom: 0;
    background: transparent !important;

    &::after {
      content: "";
      border-width: 0;
    }
  }
  .clearbtn {
    width: 1rem;
    height: 100%;
    border: none;
    background-color: #e23130;
    color: #fff;
  }

  .goodsonelist {
    background-color: #fff;
    position: relative;
    padding: 0;

    .van-card__thumb {
      width: 1.8rem;
      height: 1.8rem;

      .goodsimgbox {
        img {
          width: 1.8rem;
          height: 1.8rem;
          border-radius: 0.08rem;
        }
      }
    }

    .van-card__content {
      margin-left: 0.1rem;
      position: relative;
      .van-card-title {
        font-size: 0.26rem;
        font-weight: 400;
        color: #262626;
        line-height: 0.42rem;
        display: -webkit-box;
        // -webkit-box-orient: vertical !important;
      //  /*! autoprefixer: off */
        -webkit-line-clamp: 2;
        // /* autoprefixer: on */
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .stock-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 0.24rem;
        color: #929292;
      }

      .van-card-desc {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        bottom: 0;

        .product-price {
          flex: 1;
          font-weight: 400;
          color: #fe5c42;
          line-height: 0.4rem;
        }
      }
    }

    .overGood {
      display: inline-block;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.3);
      position: absolute;
      bottom: 0rem;
      left: 0;
      border-radius: 0.08rem;

      span {
        display: inline-block;
        width: 0.96rem;
        height: 0.96rem;
        background: rgba(0, 0, 0, 0.6);
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        font-size: 0.26rem;
        font-weight: 400;
        color: #ffffff;
        line-height: 0.96rem;
        text-align: center;
      }
    }
    .van-card__footer {
      bottom: 0.07rem;
      .van-stepper {
        .van-stepper__minus,
        .van-stepper__plus {
          width: 0.25rem;
          height: 0.25rem;
        }
        .van-stepper__input {
          width: 0.25rem;
          height: 0.21rem;
        }
      }
    }
  }

  .van-content {
    padding-bottom: 1.07rem;
    .van-checkbox__label {
      width: 100%;
      margin-left: 0;
      background: transparent !important;
      padding: 0.3rem 0;
    }
    .van-checkbox {
      margin-bottom: 0.2rem;
      background-color: #fff;
      box-sizing: border-box;
      padding: 0 0.3rem;
    }
    .van-cell-swipe__wrapper {
      position: relative;
      z-index: 99;
    }
  }
  .nodata {
    button {
      padding: 0 0.3rem;
      height: 0.4rem;
      line-height: 0.4rem;
      border-radius: 0.04rem;
      margin-top: 0.15rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/cart/cart.vue